<template>
  <v-container>
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        lg6>
        <Card>
          <template slot="header">Sign Up</template>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
            >
              <v-text-field
                v-model="form.email"
                :rules="[validationRules.required, validationRules.email]"
                label="Email"
                browser-autocomplete="username"
                prepend-icon="fa-envelope"
              />
              <v-text-field
                v-model="form.password"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                :rules="[validationRules.required, validationRules.passwordLength]"
                label="Password"
                browser-autocomplete="new-password"
                prepend-icon="fa-unlock-alt"
                @click:append="showPassword = !showPassword"
              />
              <v-text-field
                v-model="form.firstName"
                :rules="[validationRules.required]"
                label="First Name"
                prepend-icon="fa-user"
              />
              <v-text-field
                v-model="form.lastName"
                :rules="[validationRules.required]"
                label="Last Name"
                prepend-icon="fa-user"
              />
              <v-text-field
                v-model="form.address1"
                :rules="[validationRules.required]"
                label="Address 1"
                prepend-icon="fa-map-marker"
              />
              <v-text-field
                v-model="form.address2"
                label="Address 2"
                prepend-icon="fa-map-marker-alt"
              />
              <v-text-field
                v-model="form.city"
                :rules="[validationRules.required]"
                label="City"
                prepend-icon="fa-building"
              />
              <v-text-field
                v-model="form.state"
                :rules="[validationRules.required]"
                label="State"
                prepend-icon="fa-monument"
              />
              <v-text-field
                v-model="form.country"
                :rules="[validationRules.required]"
                label="Country"
                prepend-icon="fa-globe-americas"
              />
              <v-text-field
                v-model="form.zip"
                label="Zip Code"
                prepend-icon="fa-hashtag"
              />
              <v-menu
                :nudge-right="30"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <v-text-field
                  v-if="false"
                  slot="activator"
                  v-model="form.dateOfBirth"
                  :rules="[validationRules.required]"
                  :disabled="!editable"
                  label="Date Of Birth"
                  prepend-icon="event"
                  readonly
                />
                <v-date-picker
                  ref="picker"
                  v-model="form.dateOfBirth"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                />
              </v-menu>
              <v-text-field
                v-model="form.phone1"
                :rules="[validationRules.required]"
                label="Primary Phone"
                prepend-icon="fa-phone-square"
              />
              <v-text-field
                v-model="form.phone2"
                label="Secondary Phone"
                prepend-icon="fa-mobile-alt"
              />
              <v-text-field
                v-model="form.emergencyContactName"
                :rules="[validationRules.required]"
                label="Emergency Contact Name"
                prepend-icon="fa-notes-medical"
              />
              <v-text-field
                v-model="form.emergencyContactPhone"
                :rules="[validationRules.required]"
                label="Emergency Contact Phone"
                prepend-icon="fa-phone-square"
              />
              <v-layout column>
                <v-btn
                  :disabled="!valid"
                  @click="submit()">
                  Submit
                </v-btn>
                <v-flex v-if="!authenticated">
                  <v-layout justify-center>
                    <router-link
                      :to="{ path: '/signin/login' }"
                      class="pa-3">Login</router-link>
                    <router-link
                      :to="{ path: '/signin/reset'}"
                      class="pa-3">Reset Password</router-link>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </Card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Cart',
  data () {
    return {
      valid: false,
      showPassword: false,
      form: {
        email: null,
        password: null,
        firstName: null,
        lastName: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
        phone1: null,
        phone2: null,
        emergencyContactName: null,
        emergencyContactPhone: null,
        dateOfBirth: null
      }
    }
  },
  computed: {
    ...mapGetters({
      authenticated: 'person/authenticated'
    })
  },
  mounted () {
    this.$refs.picker.activePicker = 'YEAR'
  },
  methods: {
    ...mapActions({
      createPerson: 'person/createPerson',
      setProxyPerson: 'person/setProxyPerson',
      login: 'person/login'
    }),
    submit () {
      if (this.$refs.form.validate()) {
        this.createPerson(this.form).then(this.redirect)
      }
    },
    redirect (response) {
      if (this.authenticated) {
        // set as the proxy user
        this.setProxyPerson({ ...response.data, ...this.form })
      } else {
        this.login(this.form).then(() => {
          this.$router.push({ name: 'Home' })
        })
      }
    }
  }
}
</script>
